import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import FeedPage from './pages/FeedPage';
import ContestPage from './pages/ContestPage';
import ContestDetailPage from './pages/ContestDetailPage';
import AdminCreateContestPage from './pages/AdminCreateContestPage';
import QuizLobbyPage from './pages/QuizLobbyPage';
import QuizRoomPage from './pages/QuizRoomPage';
import SuperAdminQueuePage from './pages/SuperAdminQueuePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import AboutPage from './pages/AboutPage';

function App() {
  const { isSignedIn, user } = useUser();

  // Pages that show Navigation and Footer
  const PagesWithNav = ({ children }) => (
    <div className="min-h-screen flex flex-col bg-background">
      <Navigation />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );

  // Pages without Navigation and Footer (Login, Signup)
  const PagesWithoutNav = ({ children }) => (
    <div className="min-h-screen bg-background">
      {children}
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<PagesWithoutNav><LoginPage /></PagesWithoutNav>} />
      <Route path="/signup" element={<PagesWithoutNav><SignupPage /></PagesWithoutNav>} />

      <Route path="/feed" element={<PagesWithNav><ProtectedRoute><FeedPage /></ProtectedRoute></PagesWithNav>} />
      <Route path="/contests" element={<PagesWithNav><ProtectedRoute><ContestPage /></ProtectedRoute></PagesWithNav>} />
      <Route path="/contests/:id" element={<PagesWithNav><ProtectedRoute><ContestDetailPage /></ProtectedRoute></PagesWithNav>} />
      <Route path="/admin/create-contest" element={<PagesWithNav><ProtectedRoute requiredRole="admin"><AdminCreateContestPage /></ProtectedRoute></PagesWithNav>} />

      <Route path="/quiz" element={<PagesWithNav><ProtectedRoute><QuizLobbyPage /></ProtectedRoute></PagesWithNav>} />
      <Route path="/quiz/:sessionId" element={<PagesWithNav><ProtectedRoute><QuizRoomPage /></ProtectedRoute></PagesWithNav>} />

      <Route path="/superadmin/queue" element={<PagesWithNav><ProtectedRoute requiredRole="superadmin"><SuperAdminQueuePage /></ProtectedRoute></PagesWithNav>} />
      <Route path="/admin" element={<PagesWithNav><ProtectedRoute requiredRole="admin"><AdminDashboardPage /></ProtectedRoute></PagesWithNav>} />

      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/about" element={<AboutPage />} />
    </Routes>
  );
}

export default App;